<template>
    <div class="conditions-settings-loader">
        <div v-for="n in 3" :key="n" class="conditions-settings-loader__skeleton-container">
            <CompassSkeleton class="conditions-settings-loader__skeleton-semi-line" />
            <CompassSkeleton :variant="CompassEnums.SkeletonVariantType.BLOCK" />
        </div>
        <div class="conditions-settings-loader__skeleton-container">
            <CompassSkeleton />
            <CompassSkeleton class="conditions-settings-loader__skeleton-semi-line" />
        </div>
        <CompassSkeleton
            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
            class="conditions-settings-loader__skeleton-button"
        />
    </div>
</template>

<style scoped lang="scss">
.conditions-settings-loader {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
    &__skeleton-container {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-2);
        .conditions-settings-loader__skeleton-semi-line {
            width: 387px;
        }
    }
    &__skeleton-button {
        width: 85px;
        align-self: end;
    }
}
</style>
